import { Link } from "wouter";
import logoImg from "@assets/Padpulse_logo_horizontal_nobg.png";

/** "PadPulse" logo plus a smaller "for Hosts". */
export function BrandLockup({ className = "" }: { className?: string }) {
  return (
    <Link href="/" className={`flex items-center gap-2.5 ${className}`} data-testid="link-logo">
      <img src={logoImg} alt="PadPulse" className="h-[34px] sm:h-[40px] lg:h-[46px] w-auto" />
      <span
        className="text-[11px] sm:text-xs font-medium leading-tight text-blue-100/80 whitespace-nowrap"
        data-testid="text-brand-tagline"
      >
        for Hosts
      </span>
    </Link>
  );
}
